import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { AncGridComponent } from './components/anc-grid/anc-grid.component';
import { AncPaginationComponent } from './components/anc-grid/anc-pagination/anc-pagination.component';
import { AncFormFieldComponent } from './components/anc-form-field/anc-form-field.component';
import { AncFormFieldForTimeComponent } from './components/anc-form-field-for-time/anc-form-field-for-time.component';
import { AncDecimalsOnlyDirective } from './directives/anc-decimals-only.directive';
import { AncAlphaNumericOnlyDirective } from './directives/anc-alphanumeric-only.directive';
import { AncNumbersOnlyDirective } from './directives/anc-numbers-only.directive';
import { AncFieldValidateDirective } from './form-validation/anc-field-validate.directive';
import { AncFormSectionComponent } from './components/anc-form-section/anc-form-section.component';
import { AncCheckboxComponent } from './components/anc-checkbox/anc-checkbox.component';
import { AncRadioComponent } from './components/anc-radio/anc-radio.component';
import { AncRadioGroupComponent } from './components/anc-radio-group/anc-radio-group.component';
import { AncSelectComponent } from './components/anc-select/anc-select.component';
import { AncEntryGridComponent } from './components/anc-entry-grid/anc-entry-grid.component';
import { AncFormAlertComponent } from './components/anc-form-alert/anc-form-alert.component';
import { AncSummaryListComponent } from './components/anc-summary-list/anc-summary-list.component';
import { AncSummaryRowComponent } from './components/anc-summary-list/anc-summary-row.component';
import { AncInfoBlockComponent } from './components/anc-info-block/anc-info-block.component';
import { AncDetailSectionComponent } from './components/anc-detail-section/anc-detail-section.component';
import { AncPanelCardComponent } from './components/anc-panel-card/anc-panel-card.component';
import { AncStatTileComponent } from './components/anc-stat-tile/anc-stat-tile.component';
import { AncStatusBadgeComponent } from './components/anc-status-badge/anc-status-badge.component';
import { CommonTabsComponent } from './components/common-tabs/common-tabs.component';
import { AncSegmentedComponent } from './components/anc-segmented/anc-segmented.component';
import { AncSearchBarComponent } from './components/anc-search-bar/anc-search-bar.component';
import { AncDatePickerComponent } from './components/anc-date-picker/anc-date-picker.component';
import { AncButtonDirective } from './components/anc-button/anc-button.directive';
import { AncDialogComponent } from './components/anc-dialog/anc-dialog.component';
import { AncBreadcrumbComponent } from './components/anc-breadcrumb/anc-breadcrumb.component';
import { AncLanguageSelectorComponent } from './components/anc-language-selector/anc-language-selector.component';
import { AncSidePanelContainerComponent } from './components/anc-side-panel-container/anc-side-panel-container.component';
import { AncPageHeaderComponent } from './components/anc-page-header/anc-page-header.component';
import { AncFileUploadComponent } from './components/anc-file-upload/anc-file-upload.component';
import { AncPhoneFieldComponent } from './components/anc-phone-field/anc-phone-field.component';
import { AncTooltipDirective } from './directives/anc-tooltip/anc-tooltip.directive';
import { AncHeaderActionsComponent } from './components/anc-header-actions/anc-header-actions.component';
import { AncActionMenuComponent } from './components/anc-action-menu/anc-action-menu.component';
import { AncToggleComponent } from './components/anc-toggle/anc-toggle.component';

@NgModule({
    declarations: [LoaderComponent],
    imports: [
        CommonModule,
        AncGridComponent,
        AncPaginationComponent,
        AncFormFieldComponent,
        AncFormFieldForTimeComponent,
        AncFieldValidateDirective,
        AncNumbersOnlyDirective,
        AncDecimalsOnlyDirective,
        AncAlphaNumericOnlyDirective,
        AncFormSectionComponent,
        AncCheckboxComponent,
        AncRadioComponent,
        AncRadioGroupComponent,
        AncSelectComponent,
        AncEntryGridComponent,
        AncFormAlertComponent,
        AncSummaryListComponent,
        AncSummaryRowComponent,
        AncInfoBlockComponent,
        AncDetailSectionComponent,
        AncPanelCardComponent,
        AncStatTileComponent,
        AncStatusBadgeComponent,
        CommonTabsComponent,
        AncSegmentedComponent,
        AncSearchBarComponent,
        AncDatePickerComponent,
        AncButtonDirective,
        AncDialogComponent,
        AncBreadcrumbComponent,
        AncLanguageSelectorComponent,
        AncSidePanelContainerComponent,
        AncPageHeaderComponent,
        AncFileUploadComponent,
        AncPhoneFieldComponent,
        AncTooltipDirective,
        AncHeaderActionsComponent,
        AncActionMenuComponent,
        AncToggleComponent
    ],
    exports: [
        LoaderComponent,
        AncGridComponent,
        AncPaginationComponent,
        AncFormFieldComponent,
        AncFormFieldForTimeComponent,
        AncFieldValidateDirective,
        AncNumbersOnlyDirective,
        AncDecimalsOnlyDirective,
        AncAlphaNumericOnlyDirective,
        AncFormSectionComponent,
        AncCheckboxComponent,
        AncRadioComponent,
        AncRadioGroupComponent,
        AncSelectComponent,
        AncEntryGridComponent,
        AncFormAlertComponent,
        AncSummaryListComponent,
        AncSummaryRowComponent,
        AncInfoBlockComponent,
        AncDetailSectionComponent,
        AncPanelCardComponent,
        AncStatTileComponent,
        AncStatusBadgeComponent,
        CommonTabsComponent,
        AncSegmentedComponent,
        AncSearchBarComponent,
        AncDatePickerComponent,
        AncButtonDirective,
        AncDialogComponent,
        AncBreadcrumbComponent,
        AncLanguageSelectorComponent,
        AncSidePanelContainerComponent,
        AncPageHeaderComponent,
        AncFileUploadComponent,
        AncPhoneFieldComponent,
        AncTooltipDirective,
        AncHeaderActionsComponent,
        AncActionMenuComponent,
        AncToggleComponent
    ]
})
export class CommonInterceptorModule {}
